import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionsType } from "../../services/CompetitionsService";
import { Spinner, SpinnerSize } from "@fluentui/react";
//import { useHistory } from "react-router-dom";
import * as L from "./layout.styles";
import CompetitionCard from "../../components/competitionCard/CompetitionCard";
import { Toggle } from "@fluentui/react/lib/Toggle";

const CompetitionsPromotioned = () =>
{
    const [competitions, setCompetitions] = useState<CompetitionsType[]>([]);
    const [error, setError] = useState<{status: boolean, message: string}>({status: false, message: ""});
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [selectedCompetitionFinished, setSelectedCompetitionFinished] = useState<boolean>(false);
    const [currentPageCompetitionsFinished] = useState<number>(0);
    //const history = useHistory();

    const elementsPerPage = 18;

    // Función auxiliar para parsear fechas de manera consistente
    const parseDate = (dateString: string): Date =>
    {
        try
        {
            // Si la fecha contiene 'T' es un datetime, extraer solo la parte de fecha
            const dateOnly = dateString.includes('T') ? dateString.split('T')[0] : dateString;
            
            if(dateOnly.includes('/'))
            {
                // Formato con barras: puede ser dd/mm/yyyy o mm/dd/yyyy
                const parts = dateOnly.split('/');
                if(parts.length === 3)
                {
                    const [first, second, third] = parts;
                    
                    // Si el primer número es mayor que 12, debe ser dd/mm/yyyy
                    if(parseInt(first) > 12)
                    {
                        return new Date(parseInt(third), parseInt(second) - 1, parseInt(first));
                    }
                    // Si el segundo número es mayor que 12, debe ser mm/dd/yyyy
                    else if(parseInt(second) > 12)
                    {
                        return new Date(parseInt(third), parseInt(first) - 1, parseInt(second));
                    }
                    // Si ambos son <= 12, asumir dd/mm/yyyy (formato europeo)
                    else
                    {
                        return new Date(parseInt(third), parseInt(second) - 1, parseInt(first));
                    }
                }
            }
            
            // Formato ISO o similar
            return new Date(dateOnly);
        }
        catch (error)
        {
            console.warn('Error parsing date:', dateString, error);
            return new Date(dateString); // Fallback
        }
    };

    useEffect(() =>
    {
        CompetitionsService.getCompetitionsPromotionated().then((response: CompetitionsType[]) =>
        {
            // Ordenar las competiciones por fecha de finalización (más recientes primero para finalizadas)
            const sortedCompetitions = response.sort((a, b) =>
            {
                const dateA = parseDate(a.endDate);
                const dateB = parseDate(b.endDate);
                
                // Para competiciones finalizadas, mostrar las más recientes primero
                // Para competiciones activas, mostrar las que terminan antes primero
                const now = new Date();
                const aFinished = dateA < now;
                const bFinished = dateB < now;
                
                if(aFinished && bFinished)
                {
                    // Ambas finalizadas: más recientes primero
                    return dateB.getTime() - dateA.getTime();
                }
                else if(!aFinished && !bFinished)
                {
                    // Ambas activas: las que terminan antes primero
                    return dateA.getTime() - dateB.getTime();
                }
                else
                {
                    // Una finalizada y otra activa: activas primero
                    return aFinished ? 1 : -1;
                }
            });
            
            setCompetitions(sortedCompetitions);
        },
        (error: any) =>
        {
            setError(error);
        })
        .finally(() =>
        {
            setLoading(false);
        });
    }, []);

    const totalPages = Math.max(1, Math.ceil(competitions.filter((c) => parseDate(c.endDate).getTime() <= Date.now()).length / elementsPerPage));

    //const totalPagesCompetitionsFinished = Math.max(1, Math.ceil(competitions.filter((c) => parseDate(c.endDate).getTime() > Date.now()).length / elementsPerPage));

    const getCurrentPageElements = (): CompetitionsType[] =>
    {
        const start = currentPage * elementsPerPage;

        // Filtrar competiciones no finalizadas usando parseDate consistente
        let competitionsFilterNotFinishedCompetition = competitions.filter((c) => parseDate(c.endDate).getTime() > Date.now());

        return competitionsFilterNotFinishedCompetition.slice(start, start + elementsPerPage);
    };

    const getCurrentPageElementsCompetitionsFinished = (): CompetitionsType[] =>
    {
        const start = currentPageCompetitionsFinished * elementsPerPage;
        // Filtrar competiciones finalizadas usando parseDate consistente
        const competitionsFilterFinishedCompetition = competitions.filter((c) => parseDate(c.endDate).getTime() < Date.now());

        return competitionsFilterFinishedCompetition.slice(start, start + elementsPerPage);
    };

    const handlePreviousPage = () =>
    {
        setCurrentPage((prev) => Math.max(prev - 1, 0));
    };

    const handleNextPage = () =>
    {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
    };

    // const handlePreviousPageCompetitionsFinished = () =>
    // {
    //     setCurrentPageCompetitionsFinished((prev) => Math.max(prev - 1, 0));
    // };

    // const handleNextPageCompetitionsFinished = () =>
    // {
    //     setCurrentPageCompetitionsFinished((prev) =>
    //         Math.min(prev + 1, totalPagesCompetitionsFinished - 1)
    //     );
    // };

    const handleToggleValueCompetitionChange = (event: React.MouseEvent<HTMLElement>, checked: boolean | undefined) =>
    {
        setSelectedCompetitionFinished(checked ?? false);
    };

    if(error.status)
    {
        return(
            <DocumentTitle title="IronIA - Competiciones">
                <div>Error: {error.message}</div>
            </DocumentTitle>
        );
    }

    return(
        <DocumentTitle title="IronIA - Competiciones">
            <section style={{maxWidth: "1450px", margin: "0 auto 20px"}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div>
                        <h2>Competiciones</h2>
                    </div>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div style={{display: "flex", marginRight: "10px", marginTop: "8px"}}>
                            <p style={{marginRight: "5px"}}>
                                Ver Competiciones Finalizadas
                            </p>
                            <Toggle checked={selectedCompetitionFinished} onChange={handleToggleValueCompetitionChange} />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <p className="descriptioncompetition ">
                            ¿Quieres aprender jugando?
                        </p>
                        <p className="descriptioncompetition ">
                            Las competiciones de IronIA te permiten conocer el mercado de los fondos de inversión gracias a nuestro simulador. Crea carteras
                            modelo, sin ningún tipo de inversión real y compite en rentabilidad con otras carteras.
                        </p>
                        <p className="descriptioncompetition ">
                            La cartera más rentable gana... y lo que gana depende del reto.
                        </p>
                    </div>
                </div>
                {loading && <Spinner size={SpinnerSize.large} />}
                {!loading &&
                (
                    <div style={
                        {
                            marginTop: "20px",
                            marginBottom: "26px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: "10px",
                            maxWidth: "100%",
                            overflow: "hidden",
                            boxSizing: "border-box",
                        }}
                    >
                        {competitions !== undefined && competitions.length > 0 && 
                        (selectedCompetitionFinished ? getCurrentPageElementsCompetitionsFinished().map((competition, competitionIndex) =>
                            (
                                <CompetitionCard key={competition.id} competition={competition} />
                            )) : 
                            getCurrentPageElements().map((competition, competitionIndex) => <CompetitionCard key={competition.id} competition={competition} />)
                        )}
                    </div>
                )}
                {competitions !== undefined && !loading ?
                ((
                    <L.PaginationContainer>
                        <L.PageCount>
                            <span>{`${currentPage + 1} de ${totalPages}`}</span>
                        </L.PageCount>
                        <L.PageButtons>
                            <button onClick={handlePreviousPage} disabled={currentPage === 0} className={currentPage === 0 ? "disabled" : ""}>
                                <i className={"ironia-icon keyboard-arrow-left"} />
                            </button>
                            <button onClick={handleNextPage} disabled={currentPage === totalPages - 1} className={currentPage === totalPages - 1 ? "disabled" : ""}>
                                <i className={"ironia-icon keyboard-arrow-right"} />
                            </button>
                        </L.PageButtons>
                    </L.PaginationContainer>
                )
                ) :
                (
                    <></>
                )}
            </section>
        </DocumentTitle>
    );
};

export default CompetitionsPromotioned;